import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRespondent } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import PersonalityBar from './PersonalityBar/PersonalityBar'
import { useScrollToTop } from 'hooks'
import PersonalityQuestion from './PersonalityQuestion/PersonalityQuestion'
import PersonalityResults from 'components/personality/PersonalityResults/PersonalityResults'
import PersonalityWelcome from 'components/personality/PersonalityWelcome/PersonalityWelcome'
import { toQuiz } from 'ducks/router'
import styles from './PersonalityQuestionPage.module.scss'
import { t } from 'ttag'

type Respondent = {
  id?: string
  personality?: any
  status?: string
  name?: string
}

const PersonalityQuestionPage = () => {
  const {
    id: uuid,
    personality,
    status,
    name,
  }: Respondent = useSelector(getRespondent)
  const dispatch = useDispatch()
  const {
    state: { ref, scrollPosition },
    handlers: { handleScroll, handleScrollToTop },
  } = useScrollToTop()

  if (personality.status === 'created') {
    return <PersonalityWelcome />
  }

  if (personality.status === 'completed') {
    return (
      <WaveContainer containerRef={ref} handleScroll={handleScroll} rollUp>
        <PersonalityResults
          scrollPosition={scrollPosition}
          handleScrollToTop={handleScrollToTop}
        />
      </WaveContainer>
    )
  }

  if (!status && !name) {
    return (
      <WaveContainer rollUp>
        <div className={styles.noUserContainer}>
          <div className={styles.noUserMessage}>
            {t`Current respondent does not exist`}
          </div>
        </div>
      </WaveContainer>
    )
  }

  return (
    <WaveContainer
      finishButtonLabel={t`Exit`}
      handleExit={() => dispatch(toQuiz({ uuid }))}
      showFinishButton
      rollUp
    >
      <PersonalityQuestion />
      <PersonalityBar />
    </WaveContainer>
  )
}

export default PersonalityQuestionPage
